import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
import UserUtils from 'utils/user-utils';
export default function trackReservationVehicleUpdated({ reservation, user, priceDifference, newLicensePlate, newVehicle, view, }) {
    try {
        const { vehicle, parkingPassType } = reservation;
        const { status } = user;
        const oldMakeModel = vehicle?.makeLabel
            ? `${vehicle.makeLabel} ${vehicle.modelLabel}`
            : null;
        const newMakeModel = newVehicle?.makeLabel
            ? `${newVehicle.makeLabel} ${newVehicle.modelLabel}`
            : null;
        const licensePlateValue = newLicensePlate
            ? newLicensePlate
            : newVehicle
                ? newVehicle.licensePlateValue
                : null;
        const properties = {
            view,
            user_logged_in: status === UserUtils.AUTH_STATE.USER,
            price_difference: priceDifference ? priceDifference : 0,
            parking_pass_type: parkingPassType,
            old_license_plate: vehicle ? vehicle.licensePlateValue : null,
            new_license_plate: licensePlateValue,
            old_make_model: oldMakeModel ? oldMakeModel : null,
            new_make_model: newMakeModel ? newMakeModel : null,
        };
        SegmentUtils.track({
            event: 'Reservation Vehicle Updated',
            properties,
            additionalOptions: {
                context: {
                    protocols: {
                        event_version: 1,
                    },
                },
            },
        });
    }
    catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage: 'Segment Event Failed - trackReservationVehicleUpdated',
        });
    }
}
